import { createSlice } from "@reduxjs/toolkit";
import { StandardQuestionTemplateType } from "./StandardQuestionTemplate.types";

const initialState = {
  StandardId: 0,
  StandardName: "",
  IsDownloading: false,
} as StandardQuestionTemplateType;

const standardQuestionTemplateSlice = createSlice({
  name: "StandardQuestionTemplate",
  initialState: initialState,
  reducers: {
    setStandardQuestionTemplateData: (
      state,
      action: { payload: StandardQuestionTemplateType }
    ) => {
      return {
        ...state,
        StandardId: action.payload.StandardId,
        StandardName: action.payload.StandardName,
        IsDownloading: action.payload.IsDownloading,
      };
    },
    setStandardQuestionTemplateStatus: (
      state,
      action: { payload: boolean }
    ) => {
      return { ...state, IsDownloading: action.payload };
    },
    reset: () => {
      return initialState;
    },
  },
});

export const standardQuestionTemplateReducerActions =
  standardQuestionTemplateSlice.actions;
export const standardQuestionTemplateReducer =
  standardQuestionTemplateSlice.reducer;
